module.exports = __webpack_public_path__ + "img/addressEle.a9fe4490.svg";